// ホーム
export const PATH_HOME = {
  path: '/',
  name: 'page:shared.simulation',
} as const

export const PATH_SIMULATION = {
  path: '/simulation',
  name: 'domain:model.simulation.title',
} as const

export const PATH_CONTRACT_LIST = {
  path: '/contracts',
  name: 'page:shared.contract_list',
} as const

export const PATH_MARGIN_REPORT = {
  path: '/margin-report',
  name: 'page:shared.margin_report',
} as const
